import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import * as React from 'react';
import { withTheme } from 'material-ui/styles';
import { connect } from 'react-redux';
import { AppState } from '../../store/reducers';
import { getIdols, Idol } from '../../store/Entities/Idols/idols.reducer';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'material-ui/Table';
import ListToolbar from '../../components/ListToolbar';
import { CircularProgress } from 'material-ui/Progress';
import FabButton from '../../components/FabButton';
import { gotoSite } from '../../store/Navigation/navigation.actions';
import { countries as availableCountries, Country } from '../../utils/country';
import Button from 'material-ui/Button';
import { filter } from 'ramda';

interface StateProps {
  selectedAppId: number;
}

interface OwnProps {
  idols: Idol[];
  loading: boolean;
}

type Props = typeof mapDispatch & OwnProps;

class IdolList extends React.PureComponent<Props, StateProps> {
  constructor(props: Props) {
    super(props);
    this.state = { selectedAppId: -1 };
  }

  private goToUrl = (url: string) => {
    const { gotoPage } = this.props;
    gotoPage(url);
  };

  private onCountryClicked = (appId: number) => {
    this.setState({ selectedAppId: appId });
  };

  public renderCountrySelect = (): JSX.Element => {
    const { selectedAppId } = this.state;

    const btnStyle = (appId: number): object => {
      return appId === selectedAppId
        ? {
            border: '1px solid rgb(225, 246, 148)',
            marginRight: 5,
          }
        : {};
    };

    return (
      <Grid container={true} style={{ width: '100%', margin: 30 }}>
        <Button
          key={-1}
          onClick={() => this.onCountryClicked(-1)}
          style={btnStyle(-1)}
        >
          All
        </Button>
        {availableCountries.map((country: Country) => {
          return (
            <Button
              key={country.id}
              style={btnStyle(country.id)}
              onClick={() => this.onCountryClicked(country.id)}
            >
              {country.shortcode}
            </Button>
          );
        })}
      </Grid>
    );
  };

  private getFilteredIdols = (): Idol[] => {
    const { selectedAppId } = this.state;
    const { idols } = this.props;
    if (selectedAppId === -1) {
      return idols;
    }

    return filter((item: Idol) => {
      if (!item.appIds) {
        return false;
      }

      return item.appIds.indexOf(selectedAppId) > -1;
    }, idols);
  };

  public render(): JSX.Element | null {
    const { loading } = this.props;
    const idols = this.getFilteredIdols();

    return (
      <div>
        <FabButton onClick={() => this.goToUrl('idols/create')} />
        <ListToolbar />
        {loading && (
          <CircularProgress style={{ color: '#e1f694', width: 60 }} size={60} />
        )}
        {!loading && (
          <Grid
            container={true}
            style={{ marginTop: 80 }}
            alignItems="center"
            justify="space-around"
          >
            {this.renderCountrySelect()}
            <Grid
              container={true}
              direction="column"
              alignItems="center"
              justify="center"
              style={{ marginTop: 80 }}
            >
              <Grid item={true}>
                <Paper elevation={4}>
                  <Table style={{ backgroundColor: '#253238' }}>
                    <TableHead style={{ backgroundColor: '#445a65' }}>
                      <TableRow>
                        <TableCell>Idol ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Slug</TableCell>
                        <TableCell>Gender</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {idols.map((idol: Idol) => {
                        return (
                          <TableRow
                            key={idol.id}
                            hover={true}
                            onClick={() =>
                              this.goToUrl(`idols/create/${idol.id}`)
                            }
                            style={{ cursor: 'pointer' }}
                          >
                            <TableCell>{idol.id}</TableCell>
                            <TableCell>{idol.name}</TableCell>
                            <TableCell>{idol.slug}</TableCell>
                            <TableCell>{idol.gender}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: AppState, ownProperties: any): OwnProps => {
  const {
    storyEdit: { loading },
  } = state;
  return {
    idols: getIdols(state),
    loading,
  };
};

const mapDispatch = {
  gotoPage: gotoSite,
};

export default withTheme()(
  connect(
    mapStateToProps,
    mapDispatch
  )(IdolList)
);



// WEBPACK FOOTER //
// ./src/modules/IdolList/index.tsx